import { isNotDefined, type PermissionType } from '@terros/common'

export type RouteScope = 'manager' | 'admin' | 'tantalim' | PermissionType

export type RouteVisibility = {
  isAdmin: boolean
  isManager: boolean
  isTantalim: boolean
  hasPermission: (permission: PermissionType) => boolean
}

export const isPageRouteVisible = (
  route: { hidden?: boolean; scope?: RouteScope },
  visibility: RouteVisibility
): boolean => {
  if (route.hidden) return false
  return isScopeVisible(route.scope, visibility)
}

const isScopeVisible = (scope: RouteScope | undefined, visibility: RouteVisibility): boolean => {
  if (isNotDefined(scope)) return true
  if (scope === 'manager') return visibility.isAdmin || visibility.isManager
  if (scope === 'admin') return visibility.isAdmin
  if (scope === 'tantalim') return visibility.isTantalim
  return visibility.hasPermission(scope)
}
